import React, { useState } from 'react'
import axiosClient from '../../front/axiosClient';
import { Link } from 'react-router-dom';
import BackButton from '../../front/components/BackButton';
import { useAuth } from '../../Context/AuthUser';
import Popup from '../../components/Popup';

function AddShopBarber() {
    const {user} = useAuth();
    const [name, setName] = useState();
    const [mobile, setMobile] = useState();
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState(null);
    const [openTime, setOpenTime] = useState();
    const [closeTime, setCloseTime] = useState();
    const [openPeriod, setOpenPeriod] = useState("AM");
    const [closePeriod, setClosePeriod] = useState("PM");

    const validator = () => {
        const errors = {};
        if (!name) errors.name = 'name is required!';
        if (!mobile) errors.mobile = 'mobile is required!';
        if (!openTime) errors.openTime = 'In time is required!';
        if (!closeTime) errors.closeTime = 'Out time is required!';
        return errors;
    }

    const handleSubmit = async (e) =>{
        e.preventDefault();
        const openHour = `${openTime} ${openPeriod}`;
        const closeHour = `${closeTime} ${closePeriod}`;
        const validateErrors = validator();
        setErrors(validateErrors);
        const { data } = await axiosClient.post(`/barber/shop-barbers.php`,
            { name, mobile, email, openHour, closeHour},
            { headers: { "Content-Type": "application/json" } }
        )
        if (data.status === 'success') {
            setName('');
            setMobile('');
            setEmail('');
            setOpenTime('');
            setCloseTime('');
            setOpenPeriod('');
            setClosePeriod('');
            setAlert({ type: "success", message: data.message });
        } else {
            setAlert({ type: "error", message: data.message });
        }
    } 
    return (
        <div>
            {alert && (
                <Popup type={alert.type} message={alert.message} />
            )}
            <div className='page-header'>
                <Link to="" style={{ fontSize: '20px', color: 'gray' }}><BackButton /></Link>
                <h4 style={{ fontSize: '16px', fontWeight: '600' }}>Staff / Add</h4>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div className='card'>
                        <h4 className='page-heading'> Add Barber</h4>
                        <div className='card-body'>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Name  <span style={{color: 'red'}}>*</span></label>
                                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter Shop Barber Name" />
                                            {errors.name && <span style={{ color: "red", fontSize: "14px", }}>{errors.name}</span>}
                                        </div>
                                    </div>
                                   
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Mobile  <span style={{color: 'red'}}>*</span></label>
                                            <input type="number" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Enter shop barber mobile" />
                                            {errors.mobile && <span style={{ color: "red", fontSize: "14px", }}>{errors.mobile}</span>}
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Email</label>
                                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter shop barber email" />
                                            {/* {errors.email && <span style={{ color: "red", fontSize: "14px", }}>{errors.email}</span>} */}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Barber In Time <span style={{color: 'red'}}>*</span></label>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <select value={openTime} onChange={(e) => setOpenTime(e.target.value)}>
                                                    <option value="">Hour</option>
                                                    {[...Array(12)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select value={openPeriod} onChange={(e) => setOpenPeriod(e.target.value)}>
                                                    <option value="AM">AM</option>
                                                    <option value="PM">PM</option>
                                                </select>
                                            </div>
                                            {errors.openTime && <span style={{ color: "red", fontSize: "14px" }}>{errors.openTime}</span>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Barber Out Time <span style={{color: 'red'}}>*</span></label>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <select value={closeTime} onChange={(e) => setCloseTime(e.target.value)}>
                                                    <option value="">Hour</option>
                                                    {[...Array(12)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select value={closePeriod} onChange={(e) => setClosePeriod(e.target.value)}>
                                                    <option value="AM">AM</option>
                                                    <option value="PM">PM</option>
                                                </select>
                                            </div>

                                            {errors.closeTime && <span style={{ color: "red", fontSize: "14px" }}>{errors.closeTime}</span>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <button type="submit" className="submit-btn">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddShopBarber
